import { Component, Injector } from '@angular/core';
import { ProgramDetailsBodyService, AuthorizationService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-program-details-body',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class ProgramDetailsBodyComponent extends BaseGridComponent {
  private readonly bodyProgramService: ProgramDetailsBodyService;
  private readonly bodyUserService: AuthorizationService;
  private readonly programDescriptionService = new FilterableService();
  private readonly veUserService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: ProgramDetailsBodyService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.bodyProgramService = injector.get(ProgramDetailsBodyService);
    this.bodyUserService = injector.get(AuthorizationService);

    this.appCardTitle = 'Program Details';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'ProgramCode',
        title: 'Program Code',
        type: 'dropdown',
        service: this.programDescriptionService,
        textField: 'ProgramCode',
        valueField: 'Id',
        name: 'ProgramId',
        isEditingDisabled: true,
        isEditingDisabledColumn: 'ProgramCode',
        refreshSecondaryData: this.populateProgramDetailsList,
      },
      {
        field: 'PLLName',
        title: 'PLL',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'PLL',
        refreshSecondaryData: this.populateProgramDetailsUserList,
      },
      {
        field: 'PIEName',
        title: 'PIE',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'PIE'
      },
      {
        field: 'VELeadName',
        title: 'VE Lead',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'VELead'
      },
      {
        field: 'WeldEngineerName',
        title: 'Weld Engineer',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'WeldEngineer'
      },
      {
        field: 'BiwManagerName',
        title: 'BIW Manager',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'BiwManager'
      },
      {
        field: 'DispenseEngineerName',
        title: 'Dispense Engineer',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'DispenseEngineer'
      },
      {
        field: 'IsSecure',
        title: 'Secure',
        editor: 'boolean',
        filter: 'boolean'
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      ProgramCode: [],
      PLL: ['', Validators.required],
      PIE: ['', Validators.required],
      VELead: ['', Validators.required],
      WeldEngineer: ['', Validators.required],
      PLLName: [],
      PIEName: [],
      VELeadName: [],
      WeldEngineerName: [],
      BiwManager: [],
      DispenseEngineer: [],
      IsActive: [],
      IsSecure: [],
      ProgramId: ['', Validators.required],
      AuditDto: []
    });
  }

  populateProgramDetailsList(dataItem: any) {
    dataItem.bodyProgramService.read('/corePrograms')
    .then(data => {

      const result = [];
      data.forEach(element => {
        if (element.IsActive) {
          result.unshift(element);
        }
      });

      if (result.length > 0) {
        result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
      }
      dataItem.programDescriptionService.next(result);
    });
  }

  populateProgramDetailsUserList(dataItem: any) {
    dataItem.bodyUserService.read('/moduleusers?moduleName=VE_Body')
      .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Name.localeCompare(b.Name));
      }
      dataItem.veUserService.next(result);
    });
  }

}
